import "../global.js";
import "../plugins/modal";
import Swiper from "swiper/swiper-bundle";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "swiper/swiper-bundle.css";
import "../plugins/featherlight";
import { get, set } from "tiny-cookie";
import EventCountdown from "./EventCountdown";
import ContentSwitcher from "./ContentSwitcher";
import ShortFullText from "./ShortFullText";
import ModalVideoPlayer from "./ModalVideoPlayer";
import ManageSubscriptions from "./ManageSubscriptions";
import ModalVideo from "./ModalVideo";
import M100 from "./M100";
import { createPopper } from "@popperjs/core";
import AudioPlayer from "./AudioPlayer.js";
import { gsap } from "gsap";
import StickySidebar from "sticky-sidebar/dist/sticky-sidebar";
import "simplebar";
import PrintButton from "./PrintButton";
// import {debounce} from '../utils';
import AnnotationsWidget from "./AnnotationsWidget";
import InlineVideoPlayer from "./InlineVideoPlayer";
import { RespSwiper } from '../utils.js';

function checkImageURL(url) {
  return url.match(/\.(jpeg|jpg|gif|png|svg)$/) != null;
}

export const CloseAlertBanner = () => {
  var cookieName = "alert-banner-a16z";

  const banners = document.querySelectorAll(".hello-bar");
  if (banners.length) {
    Array.from(banners).forEach((item) => {
      const bannerId = item.dataset.id;
      const cookie = get(cookieName) ? get(cookieName) : [];

      if (cookie.indexOf(bannerId) === -1) {
        item.removeAttribute("style");
        return false;
      } else {
        item.remove();
      }
    });
  }

  const bannerClose = document.querySelectorAll(".close-hello-bar");
  if (bannerClose.length) {
    Array.from(bannerClose).forEach((item) => {
      item.addEventListener("click", (evt) => {
        evt.preventDefault();

        const parent = item.parentElement.parentElement;
        const bannerId = parent.dataset.id;

        const cookie = get(cookieName) ? $.parseJSON(get(cookieName)) : [];
        if (cookie.indexOf(bannerId) === -1) {
          cookie.push(bannerId);
        }

        set(cookieName, JSON.stringify(cookie), {
          expires: "1Y",
        });
        parent.remove();
      });
    });
  }
};

export const MobileNav = () => {
  var navopener = $(".nav-opener"),
    navwrap = $(".nav-container"),
    links = navwrap.find("a:not(.back)"),
    navactive = "nav-active",
    back = $(".back");

  navopener.click(function (e) {
    e.preventDefault();
    $("body").toggleClass(navactive);
  });

  $(".nav-list li").each(function () {
    var item = $(this);
    var drop = item.find(".drop-down");
    var link = item.find("a").eq(0);
    if (drop.length) {
      item.addClass("hasdrop");
      if (link.length)
        link
          .addClass("hasdrop-a")
          .attr({ "data-more": "", "data-outside": "" });
    }
  });

  links.click(function () {
    $(this).hasClass("hasdrop-a") ? false : $("body").removeClass(navactive);
    $(this).closest(".nav-holder").addClass("drop-down-active");
  });

  back.click(function () {
    $(this).parents().find("a.hasdrop-a").removeClass("active");
    $(this).closest(".nav-holder").removeClass("drop-down-active");
  });

  $("html").on("click touchstart pointerdown MSPointerDown", function (e) {
    var target = $(e.target);
    if (!target.closest(navopener).length && !target.closest(navwrap).length) {
      $("body").removeClass(navactive);
      $(".drop-down-active").removeClass("drop-down-active");
    }
  });
};

export const txoSubmenu = () => {
  var txoOpener = $(".menu-opener"),
    txoBlock = $(".txo-submenu-drop"),
    txoActive = "txo-submenu-active";

  txoOpener.click(function () {
    $("body").toggleClass(txoActive);
  });

  $("html").on("click touchstart pointerdown MSPointerDown", function (e) {
    var target = $(e.target);
    if (!target.closest(txoOpener).length && !target.closest(txoBlock).length) {
      $("body").removeClass(txoActive);
    }
  });
};

export const OpenClose = () => {
  $("[data-more]").next().hide();
  $("[data-more].active").next().show();

  $("[data-more]").click(function (e) {
    if ("anchor" != $(this).attr("data-more")) {
      e.preventDefault();
    }

    $(this).hasClass("active")
      ? $(this).removeClass("active").next().slideUp(200)
      : $(this).addClass("active").next().slideToggle(200);

    if ($(this).closest("[data-accordion]").length) {
      $(this).parent().siblings().find("[data-more]").removeClass("active");
      $(this).parent().siblings().find("[data-more]").next().slideUp(200);
    }

    if ($(this).hasClass("toc-opener") || $(this).hasClass("page-name")) {
      $("body").toggleClass("toc--active");
    }
  });

  $("[data-outside]")
    .next()
    .find("a:not(.hasdrop-a):not([data-more])")
    .click(function () {
      $("[data-outside]").removeClass("active").next("").slideUp(200);
    });
  $("[data-outside]").click(function (e) {
    e.preventDefault();
    $("[data-outside]").not(this).removeClass("active").next().slideUp(200);
  });

  $("html").on("click touchstart pointerdown MSPointerDown", function (e) {
    var target = $(e.target);

    const tocOpener = ".page-name, .toc-opener";
    const tocDrop = ".nav, .top";

    if (!target.closest(tocOpener).length && !target.closest(tocDrop).length) {
      if (!$(".filter-aside").length) {
        $(tocOpener).removeClass("active").siblings(tocDrop).slideUp(200);
        $("body").removeClass("toc--active");
      }
    }

    if (
      !target.closest("[data-outside-1]").length &&
      !target.closest("[data-outside-1] + *").length
    ) {
      setTimeout(function () {
        $("[data-outside-1]").removeClass("active").next().slideUp(200);
      }, 200);
    }
  });

  $("[data-close]").click(function (e) {
    e.preventDefault();
    $(this).parent().slideUp().prev().removeClass("active");
    $("body").removeClass("toc--active");
  });
};

export const CustomSelect = () => {
  jQuery("[data-select]").each(function () {
    var item = jQuery(this),
      selectDrop = item.next(),
      linkItems = selectDrop.find("a");

    item.attr({ "data-outside": "", "data-more": "" });

    linkItems.on("click", function (e) {
      e.preventDefault();
      item.text(jQuery(this).text());
      selectDrop.slideUp(200);
      item.removeClass("active").addClass("selected");

      selectDrop.find("li").removeClass("active");
      jQuery(this).parent().addClass("active");
    });

    if (selectDrop.children().hasClass("active")) {
      item
        .text(jQuery(this).next().find(".active a").text())
        .addClass("selected");
    }
  });
};

// export const Masonry = () => {
//     jQuery(window).on('load masonry/refresh', function () {
//         jQuery('.js-masonry').masonry({
//             itemSelector: '.grid-item',
//             resize: true,
//             isOriginLeft: true,
//         });
//     });
// };

export const initInlineSVG = () => {
  let elements = Array.from(document.querySelectorAll(".inline-svg"));
  elements = elements.filter((el) => {
    return el.src.indexOf(".svg") > -1
  })

  if (elements.length === 0) return;

  // SVG cache to avoid duplicate requests
  const svgCache = {};

  async function fetchSVGFile(url) {
    // Return from cache if already fetched
    if (svgCache[url]) {
      // Return a clone of the cached SVG to avoid DOM conflicts
      return svgCache[url].cloneNode(true);
    }

    try {
      const response = await fetch(url);

      if (response.status !== 200) {
        console.warn(`Failed to fetch SVG from ${url}: ${response.statusText}`);
        return null;
      }

      let text = await response.text();

      // Check if the first line is an HTML doctype declaration
      if (text.startsWith("<!DOCTYPE html>")) {
        console.warn(
            `The content fetched from ${url} appears to be an HTML document, not an SVG.`
        );
        return null;
      }

      text = text.replace(/<\?xml.*?\?>/, "").trim();

      // Parse SVG and add viewBox if missing
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "image/svg+xml");
      const svgElement = doc.querySelector("svg");

      if (
          !svgElement.getAttribute("viewBox") &&
          svgElement.getAttribute("width") &&
          svgElement.getAttribute("height")
      ) {
        const width = svgElement.getAttribute("width");
        const height = svgElement.getAttribute("height");
        svgElement.setAttribute("viewBox", `0 0 ${width} ${height}`);
      }

      // Store in cache
      svgCache[url] = svgElement;

      // Return a clone for this specific usage
      return svgElement.cloneNode(true);
    } catch (error) {
      console.error(`Error fetching SVG from ${url}: ${error}`);
      return null;
    }
  }

  const inlineSVGFiles = async (elements) => {
    // Group elements by src to process each unique URL only once
    const elementsByUrl = {};
    elements.forEach(el => {
      const src = el.src;
      if (!elementsByUrl[src]) {
        elementsByUrl[src] = [];
      }
      elementsByUrl[src].push(el);
    });

    // Process each URL once, then apply to all matching elements
    const fetchPromises = Object.entries(elementsByUrl).map(([url, elementsForUrl]) => {
      return fetchSVGFile(url).then((svgElement) => {
        if (svgElement === null) return;

        // Replace each element with a clone of the SVG
        elementsForUrl.forEach(el => {
          const svgClone = svgElement.cloneNode(true);
          const fillClass = el.classList.contains("no-fill") ? "" : "fill-current";
          svgClone.classList.add(fillClass);
          el.parentNode.replaceChild(svgClone, el);
        });
      });
    });

    await Promise.all(fetchPromises);
  }

  inlineSVGFiles(elements)
      .then(() => console.log('SVG inlining complete'));
};

export const Tabs = () => {
  var item = $("[data-tab]"),
    classes = [];
  item.each(function () {
    classes.push($(this).data("tab"));
  });
  item.click(function (e) {
    e.preventDefault();
    var tab_href = $(this).attr("href");
    var tab_id = $(this).attr("data-tab");

    $(this).parent().parent().find("[data-tab]").removeClass("active");
    $(this).addClass("active");

    if (tab_href.length > 2) {
      $(tab_href).removeClass(classes);
      $(tab_href).addClass(tab_id);
    }

    $("#" + tab_id)
      .siblings()
      .removeClass("active");
    $("#" + tab_id).addClass("active");
  });

  $("[data-tab].active").each(function () {
    $("#" + $("[data-tab].active").data("tab")).addClass("active");
    if ($(this).attr("href").length > 2) {
      $($(this).attr("href")).addClass($(this).data("tab"));
    }
  });
};

export const SwiperSlider = () => {
  swiperUniquer(".instacart-carousel", {
    loop: true,
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
    navigation: {
      nextEl: ".instacart-carousel ~ .swiper-controls .swiper-next",
      prevEl: ".instacart-carousel ~ .swiper-controls .swiper-prev",
    },
  });

  var swiper = new Swiper(".image-slider", {
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },

    pagination: {
      el: ".image-slider .swiper-pagination",
      clickable: true,
    },
  });

  const slides = document.getElementsByClassName("swiper-slide");
  const slidesLength = slides.length;
  if (slidesLength > 1) {
    var MySwiper = new Swiper(".about-section", {
      observer: true,
      observeParents: true,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 1200,
      direction: "vertical",
      mousewheel: {
        releaseOnEdges: false,
      },

      followFinger: false,
      touchReleaseOnEdges: true,
      longSwipes: false,
      parallax: true,
      pagination: {
        el: ".about-section .swiper-pagination",
        clickable: true,
      },
      on: {
        slideChange: (swiper) => {
          const { offsetTop } = swiper.el;
          window.pageYOffset !== offsetTop &&
            window.scrollTo({
              top: offsetTop,
              behavior: "smooth",
            });
        },
        slideChangeTransitionEnd: (swiper) => {
          const activeIndex = swiper.activeIndex;
          swiper.params.mousewheel.releaseOnEdges =
            activeIndex === 0 || activeIndex === slidesLength - 1;
        },
      },
    });
  }

  var swiper = new Swiper(".blockquote-carousel", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    adaptiveHeight: false,
    autoHeight: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 800,
    // pagination: {
    //     el: '.blockquote-carousel .swiper-pagination',
    //     clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
        centeredSlides: true,
      },
    },
  });

  var swiperGlLatest = new Swiper(".gl-latest-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    // centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: ".gl-latest-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      860: {
        slidesPerView: 3,
      },
      1100: {
        slidesPerView: 4,
        loop: false,
      },
    },
  });

  var swiperInstafeed = new Swiper(".instafeed-slider", {
    spaceBetween: 30,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });

  var swiperMarquee = new Swiper(".marquee-slider", {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 20000,
    slidesOffsetAfter: 0,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });

  var swiperLatest = new Swiper(".latest-slider", {
    slidesPerView: "1",
    spaceBetween: 32,
    loop: true,
    autoplay: true,
    breakpoints: {
      1024: {
        autoplay: false,
        loop: false,
        slidesPerView: "2",
      },
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  });

  var swiperPortfolio = new Swiper(".fm-portfolio-slider", {
    adaptiveHeight: true,
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  });

  var swiperCFMfeatured = new Swiper(".featured-content-slider", {
    slidesPerView: "auto",
    spaceBetween: 12,
    adaptiveHeight: true,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: ".featured-content-slider .swiper-next",
      prevEl: ".featured-content-slider .swiper-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: "auto",
        spaceBetween: 18,
      },
      1440: {
        slidesPerView: 5,
      },
    },
  });

  var swiperCFMfeaturedEndless = new Swiper(
    ".featured-content-slider-endless",
    {
      slidesPerView: "auto",
      spaceBetween: 12,
      adaptiveHeight: true,
      loop: true,
      roundLengths: true,
      loopAdditionalSlides: 10,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: ".featured-content-slider-endless .swiper-next",
        prevEl: ".featured-content-slider-endless .swiper-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: "auto",
          spaceBetween: 18,
        },
        1440: {
          slidesPerView: 5,
        },
      },
    }
  );

  var swiperThesis = new Swiper(".fm-thesis-slider", {
    slidesPerView: 1.9,
    spaceBetween: 12,
    loop: true,
    adaptiveHeight: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: "fm-thesis-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 21,
      },
      1600: {
        slidesPerView: 5,
        spaceBetween: 24,
      },
    },
  });

  var swiperhxf = new Swiper(".hxf-the-vision-slider", {
    slidesPerView: 1,
    spaceBetween: 9,
    loop: true,

    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    pagination: {
      el: ".hxf-the-vision-slider .swiper-pagination",
      clickable: true,
    },

    breakpoints: {
      640: {
        spaceBetween: 16,
        slidesPerView: 2,
        slidesPerGroup: 2,
      },

      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },

      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },

      1280: {
        spaceBetween: 16,
        slidesPerView: 5,
        slidesPerGroup: 5,
      },
    },
  });

  var swiperResources = new Swiper(".adm-resources-slider", {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    adaptiveHeight: true,
    pagination: {
      el: ".adm-resources-slider .swiper-pagination",
      clickable: true,
    },
  });

  var swiperBhTheme = new Swiper(".bh-theme-slider", {
    slidesPerView: "auto",
    spaceBetween: 9,
    loop: true,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },

    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },

    breakpoints: {
      768: {
        spaceBetween: 16,
      },
    },
  });

  var swiperBhPortfolio = new Swiper(".bh-portfolio-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    speed: 2000,
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  });

  var swiperEventTextWithImageSwiper = new Swiper(
    ".event-text-with-image-slider",
    {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 2000,
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
    }
  );

  var swiperEventTextWithImageSwiperV2 = new Swiper(
      ".event-text-with-image-slider-v2",
      {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        rewind: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        speed: 1500,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          beforeTransitionStart: function() {
            const activeSlide = this.slides[this.activeIndex];
            if (activeSlide) {
              activeSlide.style.transition = 'opacity 700ms ease';
              activeSlide.style.opacity = '0';
            }
          },
          transitionStart: function() {
            const nextSlide = this.slides[this.activeIndex];
            if (nextSlide) {
              nextSlide.style.transition = 'opacity 700ms ease';
              nextSlide.style.opacity = '0';

              setTimeout(() => {
                nextSlide.style.opacity = '1';
              }, 600);
            }
          }
        }
      }
  );

  const swiperBhSlides = document.querySelectorAll(
    ".bh-partner-spotlight_slider .swiper-slide"
  );
  if (swiperBhSlides.length > 1) {
    var swiperBhPartnerSpotlight = new Swiper(".bh-partner-spotlight_slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      adaptiveHeight: true,
      pagination: false,
      speed: 800,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
    });
  }

  var swiperBhSubcategory = new Swiper(".bh-subcategory-slider--swiper", {
    slidesPerView: "auto",
    spaceBetween: 18,
    loop: true,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    slideToClickedSlide: true,

    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },

    on: {
      slideChange: function () {
        initInlineSVG();
      },
    },
  });

  var swiperBhTestimonial = new Swiper(".bh-testimonial-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  });

  var swiperGmfeatured = new Swiper(".gm-featured-slider", {
    slidesPerView: 1,
    spaceBetween: 12,
    adaptiveHeight: true,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".gm-featured-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 28,
      },
      1600: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
  });

  var swiperEntfeatured = new Swiper(".ent-featured-slider", {
    slidesPerView: "auto",
    spaceBetween: 12,
    adaptiveHeight: true,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: "auto",
        spaceBetween: 18,
      },
      1440: {
        slidesPerView: 5,
      },
    },
  });

  var swiperData = new Swiper(".data-slider", {
    loop: false,
    pagination: {
      el: ".data-slider .swiper-pagination",
      clickable: true,
    },
  });

  var swiperYear = new Swiper(".year-slider", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    adaptiveHeight: true,
    navigation: {
      nextEl: ".year-slider .swiper-button-next",
      prevEl: ".year-slider .swiper-button-prev",
    },
  });

  var swiperCMFeatured = new Swiper(".seed-featured-slider", {
    slidesPerView: "auto",
    spaceBetween: 12,
    loop: true,
    adaptiveHeight: true,
    roundLengths: true,
    loopAdditionalSlides: 30,
    centeredSlides: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: "auto",
        spaceBetween: 18,
      },
      1440: {
        slidesPerView: 5,
      },
    },
  });

  var swiperClfSpotlight = new Swiper(".clf-spotlight-slider", {
    slidesPerView: 2,
    spaceBetween: 38,
    loop: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        loop: true,
      },
    },
    // effect: 'fade',
  });

  var swiperClfTxt = new Swiper(".clf-txt-slider", {
    direction: "vertical",
    slidesPerView: 3.3,
    spaceBetween: 30,
    speed: 1000,
    loop: true,
    watchSlidesProgress: true,
    roundLengths: true,
    allowTouchMove: false,
    autoplay: {
      delay: 1200,
    },

    on: {
      progress(e, globalProgress) {
        for (let r = 0; r < e.slides.length; r += 1) {
          const slide = e.slides[r].firstElementChild;
          const progress = e.slides[r].progress;
          let progressAbs = Math.abs(progress);
          let rgb = hexToRgb(slide.dataset.color);
          let opacity = 0;
          let strokeOpacity = 0;
          if (progress < 0.1 && progress > -0.1) {
            opacity = 1;
            strokeOpacity = 0;
          } else {
            if (progress >= 1 || progress < -1) {
              opacity = 0;
              strokeOpacity = 0.25;
            } else if (progress >= 0.1 && progress <= 1) {
              opacity = math.lerp(1, 0, progressAbs);
              strokeOpacity = math.lerp(0.25, 0, progressAbs);
            } else if (progress <= -0.1 && progress >= -1) {
              opacity = math.lerp(1, 0, progressAbs);
              strokeOpacity = math.lerp(0, 0.25, progressAbs);
            }
          }
          slide.style.color = `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity})`;
          slide.style.webkitTextStrokeColor = `rgba(79, 99, 38,${strokeOpacity})`;
        }
      },
      setTransition(e, t) {
        for (let r = 0; r < e.slides.length; r += 1) {
          const o = e.slides[r].firstElementChild;
          o.style.transitionDuration = `${t}ms`;
        }
      },
    },
  });

  // var swiperClfSpotlight = new Swiper(".clf-feed-slider", {
  // slidesPerView: 'auto',
  // spaceBetween: 5,
  // loop: true,

  // autoplay: {
  //     delay: 2500,
  //     disableOnInteraction: true,
  // },

  // pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true,
  // },
  //     spaceBetween: 30,
  //     centeredSlides: true,
  //     speed: 6000,
  //     autoplay: {
  //         delay: 1,
  //     },
  //     loop: true,
  //     slidesPerView:'auto',
  //     allowTouchMove: false,
  //     disableOnInteraction: true
  // });

  var swiperClfFeedMarquee = new Swiper(".clf-feed-marquee", {
    spaceBetween: 20,
    centeredSlides: true,
    speed: 20000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: false,
  });

  var swiperPodcastRating = new Swiper(".podcast-rating-slider", {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: ".podcast-rating-slider .swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
  });

  var swiperSlider4col = new Swiper(".js-slider-4", {
    spaceBetween: 24,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 800,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
    },
    on: {
      beforeInit: function () {
        var slides = this.el.querySelectorAll(".swiper-slide");
        if (slides.length < 3) {
          this.params.loop = false;
          this.params.navigation = false;
          this.params.autoplay = false;
          this.params.allowTouchMove = false;

          // Скрываем весь блок управления
          var controls = this.el.querySelector(".swiper-controls");
          if (controls) {
            controls.style.display = "none";
          }
        }
      },
    },
  });

  var swiperSlider4col = new Swiper(".js-slider-3", {
    spaceBetween: 24,
    slidesPerView: 1,
    loop: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".js-slider-3 .swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

    var swiperSliderListenWatch = new Swiper('.js-slider-5', {
        spaceBetween: 24,
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    swiperUniquer('.js-slider-related', {
        spaceBetween: 26,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".js-slider-related .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            }
        }
    });

  var aiSwiper = new Swiper(".ai-featured-thumb-slider", {
    slidesPerView: "auto",
    spaceBetween: 24,
    loop: false,
    autoplay: false,
    watchOverflow: true,
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        loop: false,
      },
    },
  });

  var swiperAiRobotics = new Swiper(".ai-robotics-slider .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 12,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
    },
  });

  var swiperEventVideoThumbnailsSlider = new Swiper(
    ".event-video-section .video-thumbnails-container",
    {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        enabled: true,
        delay: 2500,
        disableOnInteraction: false,
      },
      effect: "fade",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }
  );

  var swiperEventImageSlider = new Swiper(
    ".event-image-slider .image-slider-container",
    {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        enabled: true,
        delay: 2500,
        disableOnInteraction: false,
      },
      effect: "fade",
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
    }
  );

  var swiperSuccessStoriesImpact = new Swiper(
    ".success-stories-impact-slider .swiper-container",
    {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }
  );

  var siwperTweetSlider = new Swiper(".component-tweets--slider", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
    },
  });

  var swiperBoaQuestions = new Swiper(".boa-questions-slider", {
    slidesPerView: 1,
    spaceBetween: 23,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 3,
      }
    },
  });

  var swiperFintechNetwork = new Swiper(".fintech-network-slider", {
    slidesPerView: 1,
    loop: true,
    speed: 1300,
    autoplay: {
      enabled: true,
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
  });

  var slidequote = new Swiper(".quote-slider", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 14000,
      disableoninteraction: false,
    },
  });

  var vaultslider = new Swiper(".vault-slider", {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 24,
      }
    },
  });

  var cartslider = new Swiper(".top-insights-cards-slider", {
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 48,
      }
    },
  });
};

/*
 * Function adding unique slider (for sliders with the same class) ID to each slider
 * The container name selector with the same unique id are adding to pagination and navigation also
 * and changing the Loop option to false if slider includes less slides than it should show per view
 * */
const swiperUniquer = (container, options) => {
  const slidersList = document.querySelectorAll(container);

  if (typeof slidersList !== "object" || slidersList.length === 0) {
    return false;
  }
  const updateValue = (value, containerName, sliderId) => {
    if (value) {
      return (
        containerName +
        "[slider-id-" +
        sliderId +
        "]" +
        " " +
        value.replace(containerName, "")
      );
    }
    return null;
  };

  slidersList.forEach((slider, sliderId) => {
    slider.setAttribute("slider-id-" + sliderId, "");
    let loop = options?.loop;

    if (
      options?.loop &&
      options?.slidesPerView &&
      slider.querySelectorAll(".swiper-slide").length <= options?.slidesPerView
    ) {
      loop = false;
    }

    const uniqueOpt = {
      ...options,
      ...{
        loop: loop,
        pagination: {
          el: updateValue(options?.pagination?.el, container, sliderId),
        },
        navigation: {
          nextEl: updateValue(options?.navigation?.nextEl, container, sliderId),
          prevEl: updateValue(options?.navigation?.prevEl, container, sliderId),
        },
      },
    };

    new Swiper(container + "[slider-id-" + sliderId + "]", uniqueOpt);
  });
};

export const MobileSwiper = () => {
    RespSwiper(".book-slider", 1024, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: false,
        adaptiveHeight: false,
        centeredSlides: true,
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        },
    });

    RespSwiper(".pp-boxes-frame .swiper-container", 768, {
        slidesPerView: 1,
        // slidesPerView: 1.22,
        loop: false,
        spaceBetween: 25,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
    });
};

export const SocialNetworks = () => {
  $(".js-dropdown > a").on("click", (e) => {
    e.preventDefault();
  });

  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  document.querySelectorAll(".js-dropdown").forEach((dropdown) => {
    dropdown.addEventListener("mouseenter", () => {
      if(isTouchDevice) return;

      if (!dropdown.classList.contains("hover")) {
        dropdown.classList.add("hover");
        if (dropdown.dataset.target !== null) {
          const target = document.getElementById(dropdown.dataset.target);

          if (!target) return;
          const dropdownRect = dropdown.getBoundingClientRect();
          const top = dropdownRect.top + window.scrollY;
          target.style.left = `${dropdownRect.left}px`;
          target.style.top = `${top + dropdown.offsetHeight}px`;
          target.classList.add("hover");
        }
      }
    });
    dropdown.addEventListener("mouseleave", () => {
      if(isTouchDevice) return;

      if (dropdown.classList.contains("hover")) {
        dropdown.classList.remove("hover");
        if (dropdown.dataset.target !== null) {
          const target = document.getElementById(dropdown.dataset.target);
          if (!target) return;
          target.classList.remove("hover");
        }
      }
    });
    dropdown.addEventListener("click", () => {
      if(!isTouchDevice) return;

      if (dropdown.classList.contains("hover")) {
        dropdown.classList.remove("hover");
      } else {
        dropdown.classList.add("hover");
      }
    });
  });
};

export const moveContent = () => {
  var win = jQuery(window);
  var wrapper = jQuery("#wrapper");
  var videoHold = jQuery(".aside-article .text");

  var desktopContent = jQuery(".desktop-content");
  var mobileContent = jQuery(".mobile-content");

  function init() {
    if (wrapper.css("z-index") == 99) {
      mobileContent.append(videoHold);
    } else {
      desktopContent.append(videoHold);
    }
  }

  init();

  win.resize(function () {
    init();
  });

  const topContent = () => {
    const item = $(".single-company .top-content");
    const resize = function () {
      if (win.width() < 1280) {
        item.prependTo(".single-company .cols-wrapper");
      } else {
        item.prependTo(".single-company .content-col");
      }
    };

    resize();
    win.on("load resize orientationchange", resize);
  };

  topContent();

  const rightSide = () => {
    const item = $(".single-company .aside-col.b");
    const resize = function () {
      if (win.width() < 1280) {
        item.appendTo(".single-company .aside-col.a");
      } else {
        item.appendTo(".single-company .cols-wrapper");
      }
    };

    resize();
    win.on("load resize orientationchange", resize);
  };

  rightSide();

  const moveItemTo = () => {
    const items = document.querySelectorAll('[data-move-to]');
    if (items.length === 0) {
      return;
    }

    items.forEach(el => {
      const destinationSelector = el.getAttribute('data-move-to');
      const destination = document.querySelector(destinationSelector);
      const destinationParent = destination.closest('[data-holder-parent]')

      if (!destination) {
        console.error(`Destination not found: ${destinationSelector}`);
        return;
      }

      if (el.children.length > 0) {
        if(destinationParent) {
          destinationParent.classList.add('has-content');
        }

        while (el.children.length > 0) {
          destination.appendChild(el.firstChild);
        }
      }
    });
  };

  moveItemTo();
};

export const Anchor = () => {
  $(
    'a.go-top[href*="#"]:not([href="#"]), a.scroll-to[href*="#"]:not([href="#"])'
  ).click(function () {
    var headerHeight = $("#header").outerHeight();
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top - headerHeight,
          },
          1000
        );
        return false;
      }
    }
  });
};

export const goTop = () => {
  var win = jQuery(window);

  jQuery(".go-top").each(function () {
    var backBtn = jQuery(this);

    win.on("load scroll", function () {
      var offset = jQuery("#header").outerHeight();

      if (win.scrollTop() > offset) {
        backBtn.addClass("visible");
      } else {
        backBtn.removeClass("visible");
      }
    });
  });
};

export const Hover = (items = "[data-hover]") => {
  document.querySelectorAll(items).forEach(function (dropdown) {
    dropdown.addEventListener("mouseenter", (e) => {
      if (!dropdown.classList.contains("hover")) {
        setTimeout(() => {
          dropdown.classList.add("hover");
        }, 50);
      }
    });
    dropdown.addEventListener("mouseleave", (e) => {
      if (dropdown.classList.contains("hover")) {
        setTimeout(() => {
          dropdown.classList.remove("hover");
        }, 50);
      }
    });
  });
};

export const initLightbox = () => {
  $(".single-blog-post .chart .zoom").each((link_id, link) => {
    if (checkImageURL(link.getAttribute("href"))) {
      $(link).addClass("image-link-popup").featherlight();
    }
  });

  $(".single-blog-post .wp-content a img").each(function () {
    if (
      $(this).closest(
        ".related-reading, .contributors-block, .watch-video, .logo-list"
      ).length
    ) {
      return;
    }
    let link = $(this).parent().closest("a");
    link.wrap('<div class="img_photo"></div>');
    // link.after('<a href="#" class="icon-twitter share"></a>')

    if (!link.hasClass("image-link-popup")) {
      if (checkImageURL(link.attr("href"))) {
        $(link).addClass("zoom image-link-popup").featherlight();

        link.append('<span class="icon-zoom"></span>');
      }
    }
  });

  $(".wp-caption img").each(function () {
    if ($(this).closest(".related-reading").length) {
      return;
    }
    let link = $(this).parent().closest(".wp-caption a");
    let src = $(this).attr("src");

    if (!link.length) {
      if (checkImageURL(src)) {
        $(this).wrap("<a href=" + src + ' class="zoom image-link-popup"></a>');
        $(this).parent().closest(".wp-caption a").featherlight();

        $(this)
          .parent()
          .closest(".wp-caption a")
          .on("click", function () {
            let desc = $(this).parent().find(".wp-caption-text").html();

            if (desc) {
              $(".featherlight-content").remove(".desc");
              $(".featherlight-content").append(
                '<div class="desc">' + desc + "</div>"
              );
            }
          });

        $(this)
          .parent()
          .closest(".wp-caption a")
          .append('<span class="icon-zoom"></span>');
      }
    }
  });

  $(".image-link-popup").on("click", function () {
    let desc = $(this)
      .parent()
      .closest(".chart-hold")
      .find(".caption p")
      .html();

    if (desc) {
      $(".featherlight-content").remove(".desc");
      $(".featherlight-content").append('<div class="desc">' + desc + "</div>");
    }
  });
};

export const initM100 = () => {
  const m100Widgets = Array.prototype.slice.call(
    document.querySelectorAll(".m100-table-wrapper")
  );
  if (0 === m100Widgets.length) return;
  m100Widgets.forEach((table) => {
    new M100(table);
  });
};

export const FixedHeader = () => {
  const pageNav = $(".page-nav, .mobile-drawer");
  const header = $("#header");

  const announcementBar = $(".hello-bar").outerHeight() || 0;

  const defaultHeroHeight =
    $(
      '[class*="hero"], .article-banner--new, #advanced-search-page'
    ).outerHeight() || 0;
  const customStickyAnchorElement = $(".custom-sticky-anchor");
  console.log(customStickyAnchorElement);
  const stickyPoint = customStickyAnchorElement.length
    ? customStickyAnchorElement.offset().top +
      customStickyAnchorElement.outerHeight() -
      header.outerHeight()
    : announcementBar + defaultHeroHeight;

  const win = $(window);

  win.on("scroll load", function () {
    const scrollTop = win.scrollTop();
    if (scrollTop > announcementBar) {
      header.addClass("header-sticky");
    } else {
      header.removeClass("header-sticky");
    }

    if (scrollTop > stickyPoint) {
      pageNav.addClass("show");
    } else {
      pageNav.removeClass("show");
    }
  });

  $('.page-nav:not(.custom-page-nav) a[href*="#"]:not([href="#"])').click(function (e) {
    var target = $(this.hash);
    $("body").removeClass("toc--active");
    if (target.length) {
      e.preventDefault();

      let scrollTo = target.offset().top;

      /*
        BEGIN case study the sticky blocks are not calculating their scrolling position properly
       */
      // if(target.hasClass('is-sticky-block')){
      //   const prev = target.prev();
      //   if(prev.length && prev.hasClass('sticky-anchor')){
      //     const offset = target.css('margin-top');
      //     if(prev.length){
      //       scrollTo = prev.offset().top + parseInt(offset);
      //     }
      //   }
      // }
      /* END */

      $("html, body").animate(
        {
          scrollTop: scrollTo - 108 ,
        },
        400
      );
    }
  });
};

export const eventCountdown = () => {
  const elements = document.querySelectorAll("[data-event-countdown]");

  if (elements) {
    Array.from(elements).forEach((element) => {
      new EventCountdown(element);
    });
  }
};

export const contentSwitcher = () => {
  const elements = document.querySelectorAll("[data-content-switcher]");

  if (elements) {
    Array.from(elements).forEach((element) => {
      new ContentSwitcher(element);
    });
  }
};

export const shortFullText = () => {
  const elements = document.querySelectorAll(".short-full-text");

  if (elements) {
    Array.from(elements).forEach((element) => {
      new ShortFullText(element);
    });
  }
};

export const initShare = () => {
  const getShareLink = (link, title, share) => {
    const templates = {
      twitter: "https://twitter.com/intent/tweet?url=%link%&text=%title%",
      linkedin:
        "https://www.linkedin.com/shareArticle?mini=true&url=%link%&title=%title%",
      facebook: "https://www.facebook.com/sharer/sharer.php?u=%link%",
      hackernews: "http://news.ycombinator.com/submit?link=%link%",
      whatsapp: "https://api.whatsapp.com/send?text=%title%-%link%",
      flipboard:
        "https://share.flipboard.com/bookmarklet/popout?v=2&title=%title%&url=%link%",
      reddit: "https://www.reddit.com/submit?url=%link%&title=%title%",
      pinterest:
        "http://pinterest.com/pin/create/button/?url=%link%&description=%title%",
    };

    return templates[share].replace("%link%", link).replace("%title%", title);
  };

  var Config = {
    Link: "a.share",
    Width: 500,
    Height: 500,
  };

  $("[data-share-title]").on("click", function (e) {
    var item = $(this);
    e.preventDefault();
    const link = encodeURIComponent(item.attr("href"));
    const title = encodeURIComponent(item.data("shareTitle"));
    const type = item.data("share");

    const popupLink = getShareLink(link, title, type);

    var px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2),
      py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);

    var popup = window.open(
      popupLink,
      "social",
      "width=" +
        Config.Width +
        ",height=" +
        Config.Height +
        ",left=" +
        px +
        ",top=" +
        py +
        ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1"
    );
    if (popup) {
      popup.focus();
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    }
  });

  $("[data-share-link]").on("click", (e) => {
    e.preventDefault();
    var input = document.createElement("textarea");
    var shareParent = $(e.currentTarget).parents(".social-networks");
    if (shareParent.length) {
      var shareButton = shareParent.find(".share-opener");
      if (shareButton.length) {
        var defaultToolTipText = shareButton.text();
        shareButton.text("Copied!");

        setTimeout(function () {
          shareButton.text(defaultToolTipText);
        }, 1000);
      }
    }

    input.innerHTML = $(e.currentTarget).attr("href");
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand("copy");
    document.body.removeChild(input);
  });
};

export const initVideoPopup = () => {
  document.querySelectorAll('[data-toggle="modal"]').forEach((el) => {
    new ModalVideoPlayer(el);
  });
};

export const initToc = () => {
  const tocDesktop = $(".toc-list--desktop");
  if (tocDesktop.length) {
    let activeNavItem = -1;
    const tocAnchors = $("[data-toc-header]");
    if (tocAnchors.length) {
      tocDesktop.empty();
      tocAnchors.each((i, elem) => {
        const $elem = $(elem);
        const $li = $("<li/>");
        const $anchor = $("<a/>")
          .attr("href", `#${$elem.attr("id")}`)
          .text($elem.attr("data-toc-header"));
        if (0 === i) {
          $anchor.addClass("active");
        }
        $li.append($anchor).appendTo(tocDesktop);
      });

      if (!tocDesktop.hasClass("disable-go-top")) {
        const $li = $("<li/>");
        const $anchor = $("<a/>")
          .attr("href", `#wrapper`)
          .addClass("go-to")
          .text("Back to top");

        $li.append($anchor).appendTo(tocDesktop);
      }

      $(".toc-list--desktop a").click(function () {
        $(this).parents(".toc-list--desktop").find("li").removeClass("active");
        $(this).parent().addClass("active");
        $(this).parents(".top").slideUp().prev().removeClass("active");
        $("body").removeClass("toc--active");
        $("html, body")
          .stop()
          .animate(
            { scrollTop: $($(this).attr("href")).offset().top - 150 },
            300
          );
        return false;
      });

      $(window)
        .scroll(() => {
          const scrollDistance = $(window).scrollTop();
          let activeItem = 0;
          tocAnchors.each(function (i) {
            if ($(this).position().top - 100 <= scrollDistance) {
              activeItem = i;
            }
          });
          if (activeItem !== activeNavItem) {
            $(".toc-list--desktop li.active").removeClass("active");
            $(".toc-list--desktop li").eq(activeItem).addClass("active");
            activeNavItem = activeItem;
          }
        })
        .scroll();

      // document.getElementById('toc-menu').removeAttribute('style');
      $("#toc-menu").removeAttr("style");
    } else {
      let empty = $("#toc-empty").data("empty");
      if (empty) {
        $(".toc-hold .title").hide();
      }
    }
  }

  const tocParticipants = $("#toc-participants");
  if (tocParticipants.length) {
    const tocAnchors = $(".response-block");
    if (tocAnchors.length) {
      let activeNavItem = -1;

      $(window)
        .scroll(() => {
          const scrollDistance = $(window).scrollTop();
          let activeItem = 0;
          tocAnchors.each(function (i) {
            if ($(this).position().top - 100 <= scrollDistance) {
              activeItem = i;
            }
          });
          if (activeItem !== activeNavItem) {
            tocParticipants.find("li.active").removeClass("active");
            tocParticipants.find("li").eq(activeItem).addClass("active");
            activeNavItem = activeItem;
          }
        })
        .scroll();
    }
  }

  const tocExecHiring = $(".exec-hiring .links-accordion");
  if (tocExecHiring.length) {
    const tocAnchors = $(".eh--article");
    if (tocAnchors.length) {
      let activeNavItem = -1;

      $(".links-accordion > li a:not(.external-link)").click(function () {
        $(this).parents(".links-accordion").find("li").removeClass("active");
        $(this).parent().addClass("active");
        if (!$(this).attr("data-more")) {
          $(this)
            .parents(".links-accordion")
            .slideUp()
            .prev()
            .removeClass("active");
        }
        let offs = $(window).width() < 1024 ? 200 : 100;
        setTimeout(() => {
          $("html, body")
            .stop()
            .animate(
              { scrollTop: $($(this).attr("href")).offset().top - offs },
              300
            );
        }, 305);
        return false;
      });

      $(window)
        .scroll(() => {
          const scrollDistance = $(window).scrollTop();
          let activeItem = 0;
          tocAnchors.each(function (i) {
            if ($(this).position().top + 220 <= scrollDistance) {
              activeItem = i;
            }
          });
          if (activeItem !== activeNavItem) {
            $(".links-accordion > li.active").removeClass("active");
            $(".links-accordion > li").eq(activeItem).addClass("active");
            activeNavItem = activeItem;
          }
        })
        .scroll();
    }
  }
};

const generatePodcastHtml = (item) => {
  const authorsHtml = item.authors
    .map((author, index) => {
      return `<a href="${author.url}">${author.name}</a>${
        index < item.authors.length - 2
          ? ", "
          : index === item.authors.length - 2
          ? ", and "
          : ""
      }`;
    })
    .join("");

  return `
    <div class="episode-row">
        <h6><a href="${item.permalink}"><span>${item.title}</span></a></h6>
        <div class="authors">${authorsHtml}</div>
        <div class="txt-wrap">
            <p>${item.excerpt ? item.excerpt : ""}</p>
        </div>
    </div>
    `;
};

export const loadMorePodcasts = () => {
  let page = 2;
  $(".load-more-podcasts").on("click", function () {
    let items = $(this).data("items");
    let postType = $(this).data("postType");
    let filter = $(this).data("filter");

    $.ajax({
      type: "post",
      dataType: "json",
      url: wp_ajax.ajaxurl,
      data: {
        action: "load_more_podcasts",
        page,
        items,
        postType,
        filter,
      },
      success: function (result) {
        if (result.status === "success" && result.posts.length) {
          let html = "";
          result.posts.map((item) => {
            html += generatePodcastHtml(item);
          });
          $(".posts-list").append(html);
          page++;
        }

        if (result.isLast) {
          $(".load-more-podcasts").hide();
        }
      },
      error: function (result) {
        console.log(JSON.stringify(result));
      },
    });
  });
};

export const filterPodcasts = () => {
  $(".podcast-series-filter").on("click", function () {
    let series = $(this).data("series");

    $(".podcast-series-filter").each(function () {
      let parentLi = $(this).closest("li");

      if (parentLi.length) {
        if ($(this).data("series") === series) {
          $(this).addClass("filter-active");
          parentLi.addClass("active").siblings().removeClass("active");
        } else {
          $(this).removeClass("filter-active");
        }
      } else {
        if ($(this).data("series") === series) {
          $(this).addClass("filter-active");
        } else {
          $(this).removeClass("filter-active");
        }
      }
    });

    $(".episode-list-content .more").hide();

    const showAllToShow = document.querySelectorAll(
      `.episode-list-content .episode-row`
    );
    showAllToShow.forEach((item) => {
      if (item.dataset.series === series) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });
  });
};

// Deprecated, will be removed on design update
export const loadMoreAnnouncements = () => {
  if (!$('[class*="employee-bio--"]').length) return;

  let page = 2;
  $(".load-more-announcements").on("click", function () {
    let items = $(this).data("items");
    let postType = $(this).data("postType");
    let tax = $(this).data("tax");
    let term = $(this).data("term");
    let field = $(this).data("field");
    let colors = $(this).data("colors");

    $.ajax({
      type: "post",
      dataType: "json",
      url: wp_ajax.ajaxurl,
      data: {
        action: "load_more_announcements",
        page,
        items,
        postType,
        tax,
        field,
        term,
        colors,
      },
      success: function (result) {
        if (result.status === "success" && result.posts.length) {
          let html = "";
          result.posts.map((item) => {
            html += generateHtml(item);
          });
          $(html).insertBefore(".recent-announcements-list li:last-child");
          page++;
        }

        if (result.isLast) {
          $(".load-more-announcements").hide();
        }
      },
      error: function (result) {
        console.log(JSON.stringify(result));
      },
    });
  });

  const generateHtml = (item) => {
    let link = item.permalink || "";
    let className = item.class || "";
    let pattern = item.pattern || "";
    let logo = item.logo || "";
    let vertical = item.verticals || "";
    let title = item.title || "";
    let authorName = item.authors || "";
    return `
        <li>
            <a href="${link}" target="_blank" rel="noopener noreferrer">
                <div class="card ${className} p1">
                    <div class="wrap">
                        <div class="pattern">
                            ${pattern}
                        </div>
                        ${
                          logo
                            ? '<div class="logo"><img src="' +
                              logo +
                              '" alt="' +
                              title +
                              '"></div>'
                            : ""
                        }
                    </div>
                </div>

                <strong>${vertical}</strong>
                <h6>${title}</h6>
                <span>${authorName}</span>
            </a>
        </li>
        `;
  };
};

export const loadMorePosts = () => {
  $(".load-more-posts").on("click", function () {
    let loadMoreLink = $(this);
    let items = loadMoreLink.data("items");
    let postType = loadMoreLink.data("postType");
    let tax = loadMoreLink.data("tax");
    let term = loadMoreLink.data("term");
    let field = loadMoreLink.data("field");
    let exclude = loadMoreLink.data("exclude");
    let layout = loadMoreLink.data("layout");
    let page = loadMoreLink.data("page");
    let watch = loadMoreLink.data("watch");
    let newsLatestPage = loadMoreLink.data("newsLatest");
    let doNotFilterCategories = loadMoreLink.data("doNotFilterCategories");
    let appendTo = loadMoreLink.data("append-to")
      ? loadMoreLink.data("append-to")
      : ".posts-list";

    $.ajax({
      type: "post",
      dataType: "json",
      url: wp_ajax.ajaxurl,
      data: {
        action: "load_more_posts",
        page,
        items,
        postType,
        tax,
        field,
        term,
        exclude,
        watch,
        newsLatestPage,
        doNotFilterCategories,
      },
      success: function (result) {
        if (result.status === "success" && result.posts.length) {
          let html = "";
          result.posts.map((item) => {
            if (layout === "card") {
              html += generateCardHtml(item);
            } else {
              html += generateHtml(item);
            }
          });
          $(appendTo).append(html);
        }

        if (result.isLast) {
          loadMoreLink.hide();
        } else {
          loadMoreLink.data("page", parseInt(page) + 1);
        }
      },
      error: function (result) {
        console.log(JSON.stringify(result));
      },
    });
  });

  const generateHtml = (item) => {
    let icon = item.icon || "";
    return `
        <li>
            <div class="heading">
                <h6>
                    <a href="${item.permalink}" target="_blank" rel="noopener noreferrer"><span>${item.title}</span>${icon}</a>${item.tags}
                </h6>
                <span class="author">${item.authors}</span>
            </div>
            <p>${item.excerpt}</p>
        </li>
        `;
  };

  const generateCardHtml = (item) => {
    let icon = item.icon || "";
    return `
        <div class="col-sm-6 col-md-3">
            <a href="${item.permalink}" class="related-item style-01 theme-blue">
                <div class="description">
                    <h6>${item.title}</h6>
                    <p>${item.authors}</p>
                </div>
                <span class="action">${item.btn_text}</span>
            </a>
        </div>
        `;
  };
};

// export const loadMoreEvents = () => {
// let page = 2;
// $('.load-more-events').on('click', function () {
//     let type = $('.active .event-type-filter').data('eventTypeId') || 0;
//     let vertical = $('.active .focus-area-filter').data('verticalId') || 0;

//     $.ajax({
//         type: 'post',
//         dataType: 'json',
//         url: wp_ajax.ajaxurl,
//         data: {
//             action: 'load_more_events',
//             page,
//             type,
//             vertical,
//         },
//         success: function (result) {
//             console.log(result);
//             if (result.status === 'success' && result.events.length) {
//                 let html = '';
//                 result.events.map(item => {
//                     html += generateItem(item);
//                 });
//                 $('.event-cards').append(html);
//                 page++;
//             }

//             if (result.isLast) {
//                 $('.load-more-events').hide();
//             }
//         },
//         error: function (result) {
//             console.log(JSON.stringify(result));
//         },
//     });
// });

// const generateItem = (item) => {
//     return `
//     <div class="col-sm-6 col-md-4 event-card-wrapper">
//         <a href="${item.permalink}" class="event-card ${item.scheme}">
//             <div class="pattern">
//                 <img class="inline-svg" src="${item.pattern}" alt="">
//             </div>

//             ${item.img ? `
//                 <div class="img" style="background-image: url('` + item.img + `');"></div>
//                 ` : ''
//     }

//             <div class="event-content">
//                 ${item.type ? `
//                 <span class="event-type">` + item.type + `</span>
//                         ` : ''
//     }

//                 <div class="event-detail">
//                     ${item.vertical ? `
//                     <span class="category">` + item.vertical + `</span>
//                         ` : ''
//     }

//                     <h6>
//                         ${item.title}
//                         ${!item.pass ? `
//                         <i class="icon-lock"></i>` : ''
//     }
//                     </h6>

//                     ${item.start ? `
//                     <time>
//                         <span>` + item.time1 + `</span>
//                         <span>` + item.time2 + ` ` + item.zone + `</span>
//                     </time>
//                     ` : ''
//     }
//                 </div>
//             </div>
//         </a>
//     </div>
//         `;
// }
// }

export const initNewsLetters = () => {
  /* DEPRECATED CLASS, USE ConnectMarketoForm INSTEAD */
  /*const blocks = document.querySelector('[data-newsletter-blocks]');
    const form = document.querySelector('[data-newsletter-form]');

    if (blocks && form) {
        new NewsLetters(blocks, form);
    }*/
};

export const initManageSubscriptions = () => {
  const el = document.querySelector("[data-manage-subscriptions]");

  if (el) {
    new ManageSubscriptions(el);
  }
};

export const initVideoModal = () => {
  ModalVideo.init();
  InlineVideoPlayer.init();
};

export const VideoControl = () => {
  $(".verticals-video-player .audio-control").click(function () {
    const parent = $(this).parents(".verticals-video-player");
    const video = parent.find("video");
    if (video.prop("muted")) {
      video.prop("muted", false);
      $(this).addClass("mute").removeClass("unmute");
    } else {
      video.prop("muted", true);
      $(this).addClass("unmute").removeClass("mute");
    }
  });

  $(".verticals-video-player .play-pause-btn").on("click", function () {
    const parent = $(this).parents(".verticals-video-player");
    const video = parent.find("video");

    if ($(this).attr("data-click") == 1) {
      $(this).attr("data-click", 0);
      $(this).text("Play");
      video.trigger("pause");
    } else {
      $(this).attr("data-click", 1);
      $(this).text("Pause");
      video.trigger("play");
    }
  });
};

export const LogoMobileWidth = () => {
  $("[data-width-mb]").each(function () {
    var item = $(this),
      width = item.attr("width"),
      mbwidth = item.data("width-mb"),
      win = $(window);
    var resizeHandler = function () {
      if (win.width() < 768) {
        item.attr("width", mbwidth);
      } else {
        item.attr("width", width);
      }
    };

    resizeHandler();
    win.on("resize orientationchange", resizeHandler);
  });
};

export const ADMTimelineImage = () => {
  const blocks = document.querySelectorAll(".adm-timeline .block");
  const resizeHandler = () => {
    blocks.forEach((item, i) => {
      const img = item.querySelector(".img");
      if (i % 2) {
        img ? (img.style.marginRight = -img.clientWidth / 2 + "px") : false;
      } else {
        img ? (img.style.marginLeft = -img.clientWidth / 2 + "px") : false;
      }
    });
  };

  resizeHandler();
  addEventListener("resize", resizeHandler);
};

export const Video = () => {
  const playBtn = document.querySelectorAll(".video-control");
  const videos = document.querySelectorAll("video");

  playBtn.forEach((item) => {
    const video = item.previousElementSibling;
    item.addEventListener("click", () => {
      videos.forEach((vid) => {
        vid !== item ? vid.pause() : false;
      });
      playBtn.forEach((play) => {
        play !== item ? play.classList.remove("playing") : false;
      });
      item.classList.toggle("playing");
      if (item.classList.contains("playing")) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener("ended", () => {
      item.classList.remove("playing");
    });
  });
};

export const StickySharePanel = () => {
  const win = $(window);
  const item = $(".share-panel.style-01, [data-sticky-share]");
  if (item.length) {
    const headerHeight = jQuery("#header").outerHeight() || 0;
    const itemOffset = item.offset().top - headerHeight;
    win.on("scroll", () => {
      if (win.scrollTop() > itemOffset) {
        item.addClass("sticked");
      } else {
        item.removeClass("sticked");
      }
    });
  }
};

export const Tooltip = () => {
  const popcorn = document.querySelectorAll("[data-tooltip]");

  popcorn.forEach((item, index) => {
    const val = item.dataset.tooltip;
    const placement = item.dataset.placement;
    item.setAttribute("aria-describedby", `tooltip${index}`);
    item.insertAdjacentHTML(
      "afterend",
      `
            <span class="tooltip" aria-hidden="true" role="tooltip" id="tooltip${index}">
                <span class="tooltip-text">${val}</span>
                <span class="tooltip-arrow" data-popper-arrow></span>
            </span>
            `
    );

    const tooltip = item.nextElementSibling;

    createPopper(item, tooltip, {
      placement: placement ? placement : "top",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 20],
          },
        },
      ],
    });

    "mouseover focusin".split(" ").forEach((e) => {
      item.closest(".tooltip-holder").addEventListener(e, (s) => {
        document.body.classList.add("tooltip-active");
        item.nextElementSibling?.classList.add("hover");
        item.nextElementSibling?.setAttribute("aria-hidden", false);
      });
    });

    "mouseout focusout".split(" ").forEach((e) => {
      item.closest(".tooltip-holder").addEventListener(e, () => {
        document.body.classList.remove("tooltip-active");
        item.nextElementSibling?.classList.remove("hover");
        item.nextElementSibling?.setAttribute("aria-hidden", true);
      });
    });
  });
};

export const MobileSubscribeOpener = () => {
  const opener = $(".subscribe-panel .txt-hold h3");
  opener.click(function () {
    $(this).closest(".subscribe-panel").toggleClass("active");
  });
};

export const AudioPlayers = () => {
  const elements = document.querySelectorAll("[data-audio]");

  if (elements) {
    Array.from(elements).forEach((element) => {
      new AudioPlayer(element);
    });
  }
};

export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const math = {
  lerp: (start, end, t) => {
    return (1 - t) * start + t * end;
  },
  norm: (value, min, max) => {
    return (value - min) / (max - min);
  },
  clamp: (num, min, max) => Math.min(Math.max(num, min), max),
  map: (value, in_min, in_max, out_min, out_max) => {
    return (
      ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  },
};
export const SlickSlider = () => {
  $(".ssb-quote-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    appendDots: ".ssb-quote-wrap",
  });
};

export const tocSidebar = () => {
  const tocWrapper = $(".toc-wrapper");
  const toc = document.querySelector(".toc");
  if (tocWrapper.length && toc) {
    // eslint-disable-next-line no-new
    new StickySidebar(".toc-wrapper", {
      topSpacing: 90,
      bottomSpacing: 20,
      containerSelector: ".toc-wrapper",
      innerWrapperSelector: ".toc",
    });
    // Mobile menu for sidebar articles
    const opener = $("#toc-opener");
    if (opener.length) {
      opener.on("click", (event) => {
        event.preventDefault();
        $("body").toggleClass("toc-active");
      });
      const currentItem = tocWrapper.find(".current_page_item");
      opener.text(currentItem.find("a").text());
    }
    const tocHideSections = document.querySelectorAll(".toc-hide-section");
    window.addEventListener("scroll", () => {
      if (768 > window.innerWidth) {
        const latestKnownScrollY =
          window.pageYOffset || document.documentElement.scrollTop;
        if (document.getElementById("content").offsetTop < latestKnownScrollY) {
          if (!document.body.classList.contains("sticky-toc")) {
            document.body.classList.add("sticky-toc");
          }
        } else if (document.body.classList.contains("sticky-toc")) {
          document.body.classList.remove("sticky-toc");
        }
      }

      if (tocHideSections.length) {
        const tocBounds = toc.getBoundingClientRect();
        let hide = false;
        tocHideSections.forEach((section) => {
          if (!hide) {
            const sectionBounds = section.getBoundingClientRect();
            if (
              sectionBounds.top < tocBounds.bottom &&
              sectionBounds.bottom > tocBounds.top
            ) {
              hide = true;
            }
          }
        });
        if (hide) {
          if (!document.body.classList.contains("hide-toc")) {
            document.body.classList.add("hide-toc");
          }
        } else if (document.body.classList.contains("hide-toc")) {
          document.body.classList.remove("hide-toc");
        }
      }
    });

    if (tocHideSections.length) {
      const tocBounds = toc.getBoundingClientRect();
      let hide = false;
      tocHideSections.forEach((section) => {
        if (!hide) {
          const sectionBounds = section.getBoundingClientRect();
          if (
            sectionBounds.top < tocBounds.bottom &&
            sectionBounds.bottom > tocBounds.top
          ) {
            hide = true;
          }
        }
      });
      if (hide) {
        if (!document.body.classList.contains("hide-toc")) {
          document.body.classList.add("hide-toc");
        }
      } else if (document.body.classList.contains("hide-toc")) {
        document.body.classList.remove("hide-toc");
      }
    }
  }
};

export const VHeight = () => {
  const mobileResizeHeightThreshold = 100;
  let currentHeight = window.innerHeight;
  let currentWidth = window.innerWidth;

  const setSizes = () => {
    document.documentElement.style.setProperty("--vh", window.innerHeight + "px");
    document.documentElement.style.setProperty("--vw", window.innerWidth + "px");
  }

  const onResize = () => {
    const heightDiff = Math.abs(window.innerHeight - currentHeight);
    const skipResize = window.innerWidth === currentWidth && heightDiff < mobileResizeHeightThreshold;
    currentWidth = window.innerWidth;
    currentHeight = window.innerHeight;

    if (skipResize) {
      return;
    }

    setSizes();
  };

  setSizes();

  window.addEventListener("resize", onResize);
  window.addEventListener("orientationchange", onResize);
};

export const WPFixes = () => {
  const twitters = document.querySelectorAll(".bctt-click-to-tweet");

  twitters.forEach((item) => {
    item.closest("blockquote")?.classList.add("twitter");
  });
};

export const ExecHiring = () => {
  const aside = document.querySelector(".exec-hiring .aside");
  if (aside) {
    let win = $(window);
    let state = false;

    win.on("load scroll", function () {
      let offset = aside.offsetTop;
      const item = aside.querySelector("[data-more]");

      if (offset > 0) {
        if (!state) {
          item.classList.remove("active");
          item.nextElementSibling.style.display = "none";
        }
        state = true;
      }
    });
  }
};

export const lerpRGB = (color1, color2, t) => {
  let color = {};
  color.r = color1.r + (color2.r - color1.r) * t;
  color.g = color1.g + (color2.g - color1.g) * t;
  color.b = color1.b + (color2.b - color1.b) * t;
  return color;
};

export const socialHover = () => {
  $(".share-holder").hover(function () {
    $("body").toggleClass("share-active");
  });
};

export const PortfolioFilters = () => {
  const handleFilterClick = function () {
    let category = $(this).data("category");

    $(".ai-portfolio-list [data-category]").each(function () {
      let elementCategory = $(this).data("category");
      let parentElement = $(this).parent();

      if (category === elementCategory) {
        parentElement.addClass("show").removeClass("hide");
      } else {
        parentElement.addClass("hide").removeClass("show");
      }
    });
  };

  const registerEventListeners = function () {
    $(".ai-filter-panel a[data-category]").on("click", handleFilterClick);
  };

  $(document).ready(function () {
    registerEventListeners();
    $(".ai-filter-panel a[data-category]").eq(0).trigger("click");
  });
};

export const ContentFilters = () => {
  let counter = 0;
  let activeCategory = "";

  const showNextPosts = () => {
    let postsToShow;
    if (activeCategory === "all") {
      postsToShow = $(".ai-news-list li.hide").slice(0, 10);
    } else {
      postsToShow = $(
        '.ai-news-list li.hide[data-type="' + activeCategory + '"]'
      ).slice(0, 10);
    }

    postsToShow.removeClass("hide").addClass("show");
    counter += postsToShow.length;

    const remainingPosts =
      activeCategory === "all"
        ? $(".ai-news-list li.hide").length
        : $('.ai-news-list li.hide[data-type="' + activeCategory + '"]').length;
    if (remainingPosts === 0) {
      $(".load-more-content").addClass("hide").removeClass("show");
    }
  };

  const filterPosts = (category) => {
    activeCategory = category;
    counter = 0;

    $(".ai-news-list li").each(function () {
      const newsDataType = $(this).attr("data-type");
      if (activeCategory === "all" || newsDataType === activeCategory) {
        if (counter < 10) {
          $(this).addClass("show").removeClass("hide");
          counter++;
        } else {
          $(this).addClass("hide").removeClass("show");
        }
      } else {
        $(this).addClass("hide").removeClass("show");
      }
    });

    const loadMoreButton = $(".load-more-content");
    const totalPosts =
      activeCategory === "all"
        ? $(".ai-news-list li.hide").length
        : $('.ai-news-list li.hide[data-type="' + activeCategory + '"]').length;
    if (counter >= 10 && counter < totalPosts) {
      loadMoreButton.addClass("show").removeClass("hide");
    } else {
      loadMoreButton.addClass("hide").removeClass("show");
    }
  };

  $(".ai-filter-panel a[data-type]").on("click", function (event) {
    event.preventDefault();
    $(".ai-filter-panel .active").removeClass("active");
    $(this).parent().addClass("active");

    const clickedDataType = $(this).attr("data-type");
    filterPosts(clickedDataType);
  });

  $(".load-more-content").on("click", function (event) {
    event.preventDefault();
    showNextPosts();
  });

  filterPosts("all");
};

export const AlphaFilter = () => {
  $(".alpha-filter a").on("click", function (e) {
    e.preventDefault();

    let targetLetter = $(this).data("letter");
    let targetElement = $(".ai-glossary-list li")
      .find('[data-letter="' + targetLetter + '"]')
      .first();

    if (targetElement.length) {
      $("html, body").animate(
        {
          scrollTop: targetElement.offset().top - 50,
        },
        1000
      );
    }
  });
};

export const GlossarySearch = () => {
  let typingTimer;
  let doneTypingInterval = 300;

  function filterListItems() {
    let searchValue = $('.ai-search input[type="search"]').val().toLowerCase();

    $(".ai-glossary-list li").each(function () {
      let listItemValue = $(this)
        .find(".title span")
        .data("value")
        .toLowerCase();

      if (listItemValue.includes(searchValue)) {
        $(this).removeClass("hide").addClass("show");
      } else {
        $(this).removeClass("show").addClass("hide");
      }
    });
  }

  $('.ai-search input[type="search"]').on("input", function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(filterListItems, doneTypingInterval);
  });
};

export const ToggleParent = (selector, parent, close) => {
  const trigger = document.querySelectorAll(selector);

  trigger.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      trigger.forEach((el) => {
        el.closest(parent).classList.remove("active");
      });
      const parentDiv = e.target.closest(parent);
      parentDiv.classList.add("active");
    });

    const closeBtn = item.closest(parent).querySelector(close);

    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.target.closest(parent).classList.remove("active");
    });
  });
};

export const HeroAnimation = () => {
  const hero = document.querySelector(".ai-hero");
  if (hero) {
    hero.classList.add("ai-hero--active");
  }
};

export const OpenVideoModal = () => {
  if (document.querySelectorAll(".ai-main").length && location.hash.length) {
    const playLink = document.querySelector(
      ".ai-builder-section " + location.hash + ".watch-video"
    );
    if (playLink) {
      ModalVideo.setVideoSource(playLink);
      if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
        window.onYouTubeIframeAPIReady = () => {
          ModalVideo.launchModal(false);
        };
      } else {
        ModalVideo.launchModal(false);
      }
    }
  }
};

export const PrintButtons = () => {
  const printButtons = document.querySelectorAll("[data-print-id]");

  if (printButtons.length) {
    printButtons.forEach(function (button) {
      new PrintButton(button);
    });
  }
};

export const HxFSlider = () => {
  const quoteSlides = $(".hxf-quote-slider .swiper-slide");
  if (quoteSlides.length > 1) {
    // randomize the order of the slides
    const hxfQuoteSlider = $(".hxf-quote-slider");
    quoteSlides.detach();
    const shuffledSlides = shuffle([...quoteSlides]);
    hxfQuoteSlider.append(shuffledSlides);

    function shuffle(array) {
      let currentIndex = array.length,
        temporaryValue,
        randomIndex;

      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    }

    hxfQuoteSlider.on("init", (event, slick) => {
      const nextSlideEl = $(slick.$slides[0]);
      gsap.to(nextSlideEl.find(".animated-letter"), {
        duration: 0.01,
        opacity: 1,
        stagger: {
          each: 0.02,
        },
        onComplete: () => {
          gsap.to(nextSlideEl.find(".source"), {
            duration: 0.7,
            opacity: 1,
          });
        },
      });
    });
    hxfQuoteSlider.on(
      "beforeChange",
      (event, slick, currentSlide, nextSlide) => {
        const nextSlideEl = $(slick.$slides[nextSlide]);
        gsap.set(nextSlideEl.find(".source"), {
          opacity: 0,
        });
        gsap.set(nextSlideEl.find(".animated-letter"), {
          opacity: 0,
        });
      }
    );
    hxfQuoteSlider.on("afterChange", (event, slick, currentSlide) => {
      const nextSlideEl = $(slick.$slides[currentSlide]);
      gsap.to(nextSlideEl.find(".animated-letter"), {
        duration: 0.01,
        opacity: 1,
        stagger: {
          each: 0.02,
        },
        onComplete: () => {
          gsap.to(nextSlideEl.find(".source"), {
            duration: 0.7,
            opacity: 1,
          });
        },
      });
    });
    hxfQuoteSlider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      // adaptiveHeight: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 6000,
      speed: 1000,
    });
  }
};

// export const AnnotationsWidget = () => {
//     const annotations = $('.annotations-content-mark');
//     const annotationWidgets = [];
//
//     if(annotations.length) {
//         annotations.each((index, el) => {
//             const $el = $(el);
//             const heading = $el.data('headline');
//             const text = $el.data('text');
//             const url = $el.data('url');
//             const parent = $el.closest('p');
//             const wrap = $('<div/>')
//                 .addClass('relative');
//
//             const inner = $('<div/>')
//                 .addClass('annotations-widget');
//
//             if (heading) {
//                 let el_heading;
//                 el_heading = $('<span/>')
//                     .addClass('listen')
//                     .html(`${heading}`);
//                 inner.append(el_heading);
//             }
//
//             if(text) {
//                 let text_content = '';
//
//                 if (url && url.length > 0) {
//                     text_content = `<a href="${url}">${text}</a>`;
//                 } else {
//                     text_content = `<span>${text}</span>`;
//                 }
//
//                 const el_text = $('<div/>')
//                     .addClass('info')
//                     .html(`<p>${text_content}</p>`);
//                 inner.append(el_text);
//             }
//             parent.wrap(wrap);
//
//             inner.appendTo(parent.parent());
//             annotationWidgets.push(inner);
//         });
//
//         if(typeof MktoForms2 !== 'undefined'){
//             MktoForms2.whenReady(
//               debounce(() => {
//                   recalcAnnotationsWidget(annotationWidgets)
//               }, 100)
//             );
//         }
//
//         recalcAnnotationsWidget(annotationWidgets)
//         overlappingAnnotationWidget(annotationWidgets)
//     }
// }
//
// const recalcAnnotationsWidget = (annotationWidgets) => {
//     const wrapper = $('.aside-col.right');
//     const wrapperOffset = wrapper.offset().top;
//     const children = wrapper.children(':not(.item-center)');
//     let busyArea = 0;
//
//     children.each((index, el) => {
//         busyArea += ($(el).offset().top + $(el).outerHeight()) - wrapperOffset;
//     });
//
//     annotationWidgets.forEach((el) => {
//         $(el).css('top', '');
//         const delta = (busyArea + wrapperOffset) - $(el).offset().top;
//
//         if(delta > 0) {
//             $(el).css('top', delta + 'px');
//             busyArea = busyArea + $(el).outerHeight();
//         }
//     });
// }
//
// const overlappingAnnotationWidget = (annotationWidgets) => {
//     const wrapper = $('.item-center');
//     const children = wrapper.children();
//     const widgetLoc = [];
//
//     if(!wrapper.length || !children.length || !annotationWidgets.length)
//         return false
//
//     annotationWidgets.forEach((el) => {
//         let start = $(el).offset().top;
//         let end = start + $(el).outerHeight();
//         widgetLoc.push({start, end})
//     })
//
//     function hideAtOverlapping () {
//
//         children.each((i, childItem) => {
//             const margin = 10;
//             let start = $(childItem).offset().top - margin;
//             let end = start + $(childItem).outerHeight() + margin;
//             let isOvarlapping = false;
//
//             widgetLoc.forEach((el) => {
//                 if(el.end >= start && el.start <= end){
//                     isOvarlapping = true;
//                     return true;
//                 }
//             })
//
//             if(isOvarlapping){
//                 $(childItem).addClass('annotation-overlapping');
//             }else{
//                 $(childItem).removeClass('annotation-overlapping');
//             }
//
//         })
//     }
//
//     hideAtOverlapping()
//     document.addEventListener('scroll', hideAtOverlapping);
//     window.addEventListener('resize', debounce(hideAtOverlapping, 500));
// }

export const initTombstone = () => {
  const tombstoneWrapper = document.querySelector(".tombstone-enable");
  if (tombstoneWrapper) {
    const lastParagraphs = document.querySelectorAll(
      ".tombstone-enable > p:last-child"
    );
    if (lastParagraphs.length) {
      lastParagraphs.forEach((lastParagraph) => {
        const nbsp = document.createTextNode("\u00A0");
        const tombstoneSpan = document.createElement("span");
        tombstoneSpan.className = "tombstone";
        lastParagraph.appendChild(nbsp);
        lastParagraph.appendChild(tombstoneSpan);
      });
    }
  }
};

export const initAnnotationsWidget = () => {
  const annotationsWidgetInstance = new AnnotationsWidget();
};

export const initCopyText = () => {
  var copyButtons = jQuery(".copyButton");
  copyButtons.on("click", function () {
    const el = $(this);
    const copyText = el.parent().find(".copyTarget");
    copyText.select();
    document.execCommand("copy");
    const wrapper = el.closest(".discount-block");
    if (wrapper.length) {
      wrapper.addClass("copied");
      setTimeout(() => {
        wrapper.removeClass("copied");
      }, 2000);
    }
  });
};

export const initFullBlock = () => {
  const images = document.querySelectorAll(
    ".img-gift-row, .bi-quiz, [data-width]"
  );

  const updateImageSizes = () => {
    for (let el of images) {
      const w = el.getBoundingClientRect().width;
      el.style.setProperty("--bg-width", `${w}px`);
    }
  };

  let resizeTimeout;
  const onResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateImageSizes, 100);
  };

  window.addEventListener("resize", onResize);
  window.addEventListener("orientationchange", onResize);

  updateImageSizes();
};

export const initOuterHeight = () => {
  function setOuterHeight() {
    $("[data-height]").each(function () {
      var innerBlock = $(this).find("[data-holder]");
      var innerBlockHeight = innerBlock.outerHeight(true);
      $(this).css("height", innerBlockHeight + "px");
    });
  }

  window.addEventListener("resize", setOuterHeight);
  window.addEventListener("orientationchange", setOuterHeight);

  setOuterHeight();
};

export const initClickToTweet = () => {
  $('img[data-click_tweet="true"]').each((index, el) => {
    const $el = $(el);
    let $figure = $el.closest("figure");
    if (!$figure.length) {
      $el.wrap("<figure></figure>");
      $figure = $el.closest("figure");
    }
    $figure.addClass("figure--click-to-tweet");
    const url = $el.data("click_tweet_url");
    const quote = $el.data("click_tweet_quote");
    $(
      `<a class="click-to-tweet" href="https://twitter.com/intent/tweet?text=${quote}%20${location.href}%20${url}" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 462.799"><path fill-rule="nonzero" d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"/></svg></a>`
    ).appendTo($figure);
  });
};
